<template>
    <div class="container">

        <p class="page_title">대시보드</p>

        <section class="section sec1">
            <div class="sec_titbox">
                <p class="tit">기본 통계</p>
            </div>
            <div class="card_box">
                <div class="card card1">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/basic_icon1.png`" alt="" class="icon">
                        <p class="txt">회원가입 수</p>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">누적</p>
                            <p class="desc"><span class="num">{{ totalUser }}</span>명</p>
                        </div>
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc"><span class="num">{{ monthUser }}</span>명</p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc"><span class="num">{{ dayUser }}</span>명</p>
                        </div>
                    </div>
                </div>
                <div class="card card2">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/basic_icon2.png`" alt="" class="icon">
                        <p class="txt">번호 추출수 현황</p>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">누적</p>
                            <p class="desc"><span class="num">{{ totalDraw }}</span>개</p>
                        </div>
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc"><span class="num">{{ monthDraw }}</span>개</p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc"><span class="num">{{ dayDraw }}</span>개</p>
                        </div>
                    </div>
                </div>
                <div class="card card3">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/basic_icon3.png`" alt="" class="icon">
                        <p class="txt">Plan 결제 수</p>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc"><span class="num">{{ monthPay.length }}</span>건</p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc"><span class="num">{{ dayPay.length }}</span>건</p>
                        </div>
                    </div>
                </div>
                <div class="card card4">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/basic_icon4.png`" alt="" class="icon">
                        <p class="txt">Plan 결제금액</p>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc"><span class="num">{{ monthPay.reduce((acc, payment) => acc +
                                payment.pricing, 0).toLocaleString() }}</span>원</p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc"><span class="num">{{ dayPay.reduce((acc, payment) => acc + payment.pricing,
                                0).toLocaleString() }}</span>원</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section sec2">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">가입 · 결제 현황</p>
                </div>
                <div class="rightbox">
                    <div class="filter_box">
                        <button type="button" id="chart1_daybtn" class="filter_btn day"
                            :class="{ 'on': !isChart1Month }" @click="changeChart1Days(chart1Month)">일별</button>
                        <button type="button" id="chart1_monthbtn" class="filter_btn month"
                            :class="{ 'on': isChart1Month }" @click="changeChart1Month(chart1Year)">월별</button>
                    </div>
                </div>
            </div>
            <div class="chart_box">
                <div class="chart_top">
                    <div class="select_box">
                        <select class="select" v-model="chart1Month" v-if="!isChart1Month"
                            @change="changeChart1Days(chart1Month)">
                            <option value="1">1월</option>
                            <option value="2">2월</option>
                            <option value="3">3월</option>
                            <option value="4">4월</option>
                            <option value="5">5월</option>
                            <option value="6">6월</option>
                            <option value="7">7월</option>
                            <option value="8">8월</option>
                            <option value="9">9월</option>
                            <option value="10">10월</option>
                            <option value="11">11월</option>
                            <option value="12">12월</option>
                        </select>
                        <select class="select" v-model="chart1Year" v-if="isChart1Month"
                            @change="changeChart1Month(chart1Year)">
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                            <option value="2028">2028</option>
                        </select>
                    </div>
                </div>
                <div class="chart">
                    <Line :options="chartOptions" :data="chartData" />
                </div>
                <div class="chart_labels">
                    <div class="label">
                        <span class="line_color color1"></span>
                        <span class="label_txt">가입</span>
                    </div>
                    <div class="label">
                        <span class="line_color color2"></span>
                        <span class="label_txt">결제</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="section sec3">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">Plan 현황</p>
                </div>
                <div class="rightbox">
                    <div class="filter_box">
                        <button type="button" id="chart2_daybtn" class="filter_btn day"
                            :class="{ 'on': !isChart2Month }" @click="changeChart2Days(chart2Month)">일별</button>
                        <button type="button" id="chart2_monthbtn" class="filter_btn month"
                            :class="{ 'on': isChart2Month }" @click="changeChart2Month(chart2Year)">월별</button>
                    </div>
                </div>
            </div>
            <div class="chart_box">
                <div class="chart_top">
                    <div class="select_box">
                        <select class="select" v-model="chart2Month" v-if="!isChart2Month"
                            @change="changeChart2Days(chart2Month)">
                            <option value="1">1월</option>
                            <option value="2">2월</option>
                            <option value="3">3월</option>
                            <option value="4">4월</option>
                            <option value="5">5월</option>
                            <option value="6">6월</option>
                            <option value="7">7월</option>
                            <option value="8">8월</option>
                            <option value="9">9월</option>
                            <option value="10">10월</option>
                            <option value="11">11월</option>
                            <option value="12">12월</option>
                        </select>
                        <select class="select" v-model="chart2Year" v-if="isChart2Month"
                            @change="changeChart2Month(chart2Year)">
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                            <option value="2028">2028</option>
                        </select>
                    </div>
                </div>
                <div class="chart">
                    <Bar :options="chartOptions2" :data="chartData2" />
                </div>
                <div class="chart_labels">
                    <div class="label">
                        <span class="box_color color1"></span>
                        <span class="label_txt">Premium</span>
                    </div>
                    <div class="label">
                        <span class="box_color color2"></span>
                        <span class="label_txt">Basic</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="section sec4">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">매출 현황</p>
                </div>
                <div class="rightbox">
                    <div class="filter_box">
                        <button type="button" id="chart3_daybtn" class="filter_btn day"
                            :class="{ 'on': !isChart3Month }" @click="changeChart3Days(chart3Month)">일별</button>
                        <button type="button" id="chart3_monthbtn" class="filter_btn month"
                            :class="{ 'on': isChart3Month }" @click="changeChart3Month(chart3Year)">월별</button>
                    </div>
                </div>
            </div>
            <div class="chart_box">
                <div class="chart_top">
                    <div class="select_box">
                        <select class="select" v-model="chart3Month" v-if="!isChart3Month"
                            @change="changeChart3Days(chart3Month)">
                            <option value="1">1월</option>
                            <option value="2">2월</option>
                            <option value="3">3월</option>
                            <option value="4">4월</option>
                            <option value="5">5월</option>
                            <option value="6">6월</option>
                            <option value="7">7월</option>
                            <option value="8">8월</option>
                            <option value="9">9월</option>
                            <option value="10">10월</option>
                            <option value="11">11월</option>
                            <option value="12">12월</option>
                        </select>
                        <select class="select" v-model="chart3Year" v-if="isChart3Month"
                            @change="changeChart3Month(chart3Year)">
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                            <option value="2028">2028</option>
                        </select>
                    </div>
                </div>
                <div class="chart">
                    <Line :options="chart3Options" :data="chart3Data" />
                </div>
            </div>
        </section>

    </div>
</template>
<script setup>
import { getAdminHomeInfo, getChart1DataMonth, getChart1DataYear, getChart2DataMonth, getChart2DataYear, getChart3DataMonth, getChart3DataYear } from '@/api';
import { onMounted, ref, computed } from 'vue';
import { Bar, Line } from 'vue-chartjs'
import { createGradient } from '@/utils';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js'

// 변수 선언 부분
const totalUser = ref(0);
const monthUser = ref(0);
const dayUser = ref(0);
const totalDraw = ref(0);
const monthDraw = ref(0);
const dayDraw = ref(0);
const monthPay = ref([]);
const dayPay = ref([]);
const chart1Label = ref([]);
const chart1FirstData = ref([])
const chart1SecondData = ref([])
const chart2Label = ref([])
const chart2FirstData = ref([])
const chart2SecondData = ref([])
const chart1Year = ref('')
const chart1Month = ref('')
const chart2Month = ref('')
const chart2Year = ref('')
const isChart1Month = ref(false)
const isChart2Month = ref(false)
const chart3Label = ref([])
const chart3FirstData = ref([])
const chart3Month = ref('')
const chart3Year = ref('')
const isChart3Month = ref(false)

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement)



const chartData = computed(() => {
    return {
        labels: chart1Label.value,
        datasets: [{
            label: '가입',
            data: chart1FirstData.value,
            borderColor: '#7050f8',
            borderWidth: 3.5,
            pointBackgroundColor: '#fff',
            pointRadius: 6,
            pointBorderWidth: 3.5,
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#7050f8',
            pointHoverRadius: 8,
            pointHoverBorderWidth: 3.5,
        },
        {
            label: '결제',
            data: chart1SecondData.value,
            borderColor: '#38acf9',
            borderWidth: 3.5,
            pointBackgroundColor: '#fff',
            pointRadius: 6,
            pointBorderWidth: 3.5,
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#38acf9',
            pointHoverRadius: 8,
            pointHoverBorderWidth: 3.5,
        },
        ]
    };
});

function changeChart1Days(month) {
    isChart1Month.value = false
    getChart1DataMonth(month).then((res) => {
        chart1Label.value = res.data.regUser.map(item => item.date);
        chart1FirstData.value = res.data.regUser.map(item => item.count);
        chart1SecondData.value = res.data.payUser.map(item => item.count);
    });
}

function changeChart1Month(year) {
    isChart1Month.value = true
    getChart1DataYear(year).then((res) => {
        chart1Label.value = res.data.regUser.map(item => item.date);
        chart1FirstData.value = res.data.regUser.map(item => item.count);
        chart1SecondData.value = res.data.payUser.map(item => item.count);
    });
}

function changeChart2Days(month) {
    isChart2Month.value = false
    getChart2DataMonth(month).then((res) => {
        chart2Label.value = res.data.typeZero.map(item => item.date);
        chart2FirstData.value = res.data.typeOne.map(item => item.count);
        chart2SecondData.value = res.data.typeZero.map(item => item.count);
    });
}

function changeChart2Month(year) {
    isChart2Month.value = true
    getChart2DataYear(year).then((res) => {
        chart2Label.value = res.data.typeZero.map(item => item.date);
        chart2FirstData.value = res.data.typeOne.map(item => item.count);
        chart2SecondData.value = res.data.typeZero.map(item => item.count);
    });
}

const chartOptions = ref({
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
        }
    },
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: {
            top: 0,
            left: -18,
            right: 0,
            bottom: 0,
        }
    },
    scales: {
        x: {
            offset: true,
            ticks: {
                padding: 12,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#40395d',
                },
            },
            grid: {
                display: false,
            },
        },
        y: {
            beginAtZero: true,
            ticks: {
                stepSize: 1,
                padding: 18,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#383b40',
                },
            },
            border: {
                display: false,
            },
        },
    },
})

const chartData2 = computed(() => {
    return {
        labels: chart2Label.value,
        datasets: [{
            label: 'Premium',
            data: chart2FirstData.value,
            backgroundColor: function (context) {
                return createGradient(context, '#9750f8', '#3e1ad6');
            },
            borderRadius: 8,
            barThickness: 24,
        },
        {
            label: 'Basic',
            data: chart2SecondData.value,
            backgroundColor: function (context) {
                return createGradient(context, '#3DB3FF', '#0060bd');
            },
            borderRadius: 8,
            barThickness: 24,
        }
        ]
    };
});

const chartOptions2 = ref({
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
        }
    },
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: {
            top: 0,
            left: -18,
            right: 0,
            bottom: 0,
        }
    },
    scales: {
        x: {
            offset: true,
            ticks: {
                padding: 12,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#40395d',
                },
            },
            grid: {
                display: false,
            },
        },
        y: {
            beginAtZero: false,
            suggestedMin: 1,
            ticks: {
                stepSize: 1,
                padding: 18,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#383b40',
                },
            },
            border: {
                display: false,
            },
        },
    },
})

const chart3Data = computed(() => {
    return {
        labels: chart3Label.value,
        datasets: [{
            label: '가입',
            data: chart3FirstData.value,
            borderColor: '#7050f8',
            borderWidth: 3.5,
            pointBackgroundColor: '#fff',
            pointRadius: 6,
            pointBorderWidth: 3.5,
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#7050f8',
            pointHoverRadius: 8,
            pointHoverBorderWidth: 3.5,
        },]
    }
})

const chart3Options = ref({
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
        }
    },
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: {
            top: 0,
            left: -18,
            right: 0,
            bottom: 0,
        }
    },
    scales: {
        x: {
            offset: true,
            ticks: {
                padding: 12,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#40395d',
                },
            },
            grid: {
                display: false,
            },
        },
        y: {
            beginAtZero: false,
            suggestedMin: 1,
            ticks: {
                stepSize: 1,
                padding: 18,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#383b40',
                },
            },
            border: {
                display: false,
            },
        },
    },
})

function changeChart3Days(month) {
    isChart3Month.value = false
    getChart3DataMonth(month).then((res) => {
        chart3Label.value = res.data.price_data.map(item => item.date);
        chart3FirstData.value = res.data.price_data.map(item => item.pricing);
    });
}

function changeChart3Month(year) {
    isChart3Month.value = true
    getChart3DataYear(year).then((res) => {
        chart3Label.value = res.data.price_data.map(item => item.date);
        chart3FirstData.value = res.data.price_data.map(item => item.pricing);
    });
}

onMounted(() => {
    getAdminHomeInfo().then((res) => {
        if (res.status === 200) {
            totalUser.value = res.data.totalUser;
            monthUser.value = res.data.monthUser;
            dayUser.value = res.data.todayUser;
            totalDraw.value = res.data.totalDraw;
            monthDraw.value = res.data.monthDraw;
            dayDraw.value = res.data.todayDraw;
            monthPay.value = [...res.data.monthPayment];
            dayPay.value = [...res.data.todayPayment];
        }
    });
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    chart1Month.value = currentMonth;
    chart2Month.value = currentMonth;
    chart1Year.value = currentYear;
    chart2Year.value = currentYear;
    chart3Month.value = currentMonth;
    chart3Year.value = currentYear;
    changeChart1Days(currentMonth)
    changeChart2Days(currentMonth)
    changeChart3Days(currentMonth)
});



</script>
<style></style>